import { createContext, useCallback, useContext, useMemo } from 'react';

const DashboardCardContext = createContext(null);

export const DashboardCardProvider = ({ children, setGridCount }) => {
  const registerGrid = useCallback(() => {
    setGridCount(prev => prev + 1);
  }, [setGridCount]);

  const unregisterGrid = useCallback(() => {
    setGridCount(prev => (prev > 0 ? prev - 1 : 0));
  }, [setGridCount]);

  const value = useMemo(() => {
    return { registerGrid, unregisterGrid };
  }, [registerGrid, unregisterGrid]);

  return (
    <DashboardCardContext.Provider value={value}>
      {children}
    </DashboardCardContext.Provider>
  );
};

export const useDashboardCardContext = () => {
  return useContext(DashboardCardContext);
};
